<div class="competitor-selection-dialog" data-main-modal-overlay>
  <h3 class="dialog-title font-2xl">
    {{
      this.userSelectedProductDetailID()
        ? ("features.competitor-comparison.competitor-selection-modal-dialog.incomparableTitle"
          | translate)
        : ("features.competitor-comparison.competitor-selection-modal-dialog.title"
          | translate)
    }}
  </h3>
  <p class="dialog-description font-m">
    {{
      this.userSelectedProductDetailID()
        ? ("features.competitor-comparison.competitor-selection-modal-dialog.incomparableDescription"
          | translate)
        : ("features.competitor-comparison.competitor-selection-modal-dialog.description"
          | translate)
    }}
  </p>
  <section class="settings-group">
    @if (isLoading()) {
      <div class="loading-container">
        <div class="progress-container">
          <div class="progress-bar"></div>
        </div>
      </div>
    } @else {
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>
          {{
            "features.competitor-comparison.competitor-selection-modal-dialog.selectLabel"
              | translate
          }}</mat-label
        >
        <mat-select
          [value]="selectedCompetitorProduct()"
          (selectionChange)="handleCompetitorProductSelectionChange($event)"
          class="select"
          [panelClass]="'select-panel'"
        >
          <mat-select-trigger>
            @if (selectedCompetitorProduct()) {
              {{ competitorDisplayText() }}
            }
          </mat-select-trigger>

          @for (competitor of brandsArray(); track competitor.key) {
            <mat-optgroup class="opt-group font-3xs">{{
              competitor.value.brand
            }}</mat-optgroup>
            @for (
              competitorProduct of competitor.value.items;
              track competitorProduct.ID
            ) {
              <mat-option [value]="competitorProduct" class="option font-xs">
                <div class="option-inner">
                  @if (competitorProduct.benchmarkIconId) {
                    <claas-icon
                      class="arrow-icon"
                      [iconId]="competitorProduct.benchmarkIconId"
                      [namespace]="'pia'"
                      [size]="20"
                      [alt]="''"
                      [removeDefaultColor]="true"
                    >
                    </claas-icon>
                  }
                  <span class="option-text">{{ competitorProduct.Name }}</span>
                </div>
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }
  </section>

  <div class="legend-container">
    <h4 class="legend-title font-xs">
      {{
        "features.competitor-comparison.competitor-selection-modal-dialog.legendTitle"
          | translate
      }}
    </h4>
    <div class="legend-items-container">
      <div class="legend-item">
        <claas-icon
          class="arrow-icon"
          [iconId]="'659463'"
          [namespace]="'pia'"
          [size]="20"
          [alt]="''"
          [removeDefaultColor]="true"
        >
        </claas-icon>
        <span class="legend-description font-3xs">
          {{
            "features.competitor-comparison.competitor-selection-modal-dialog.legendAdvantage"
              | translate
          }}</span
        >
      </div>

      <div class="legend-item">
        <claas-icon
          class="arrow-icon"
          [iconId]="'659462'"
          [namespace]="'pia'"
          [size]="20"
          [alt]="''"
          [removeDefaultColor]="true"
        >
        </claas-icon>
        <span class="legend-description font-3xs">
          {{
            "features.competitor-comparison.competitor-selection-modal-dialog.legendDisadvantage"
              | translate
          }}</span
        >
      </div>
      <div class="legend-item">
        <claas-icon
          class="arrow-icon"
          [iconId]="'648420'"
          [namespace]="'pia'"
          [size]="20"
          [alt]="''"
          [removeDefaultColor]="true"
        >
        </claas-icon>
        <span class="legend-description font-3xs">
          {{
            "features.competitor-comparison.competitor-selection-modal-dialog.legendEqual"
              | translate
          }}
        </span>
      </div>
    </div>
  </div>

  <div class="buttons-container">
    <button
      type="button"
      class="button-cancel font-m"
      (click)="handleCloseCompetitorsDialogClick($event, false)"
    >
      {{
        "features.competitor-comparison.competitor-selection-modal-dialog.buttonCancel"
          | translate
      }}
    </button>
    <button
      type="button"
      (click)="
        handleCloseCompetitorsDialogClick(
          $event,
          !selectedCompetitorProduct() || isLoading()
        )
      "
      [disabled]="!selectedCompetitorProduct() || isLoading()"
      [class.disabled]="!selectedCompetitorProduct() || isLoading()"
      [routerLink]="
        !selectedCompetitorProduct() || isLoading()
          ? null
          : `/pia/${countryID()}/${languageID()}/${year()}/product/${productID()}/${displayArgumentsOrTechData()}/${computedProductDetailID()}/comparison/${$safeNavigationMigration(selectedCompetitorProduct()?.ID)}`
      "
      class="button-save font-m"
    >
      {{
        "features.competitor-comparison.competitor-selection-modal-dialog.buttonCompare"
          | translate
      }}
    </button>
  </div>
</div>
